/* eslint-disable no-mixed-operators */
/* eslint-disable no-bitwise */

/**
 * Returns a copy of the given array with the element at the specified index replaced.
 *
 * @param {Array} array - The array to update
 * @param {number} index - The non-negative index of the element to be replaced
 * @param {any} element - The new element
 * @returns {array} - The array copy with the associated element replaced
 */
export function replacedAt(array, index, element) {
  const result = Array.from(array);
  result[index] = element;
  return result;
}

type TestFn = <T = any>(item: T, index: number) => boolean;

/**
 * Returns two arrays separated by a logical test
 *
 * @param {Array} array - The array to seperate
 * @param {} test - Any function that returns a boolean
 * @returns {Array} - An array of separated arrays in the order of [pass, fail]
 */
export const separate = <T = any>(array: T[], test: TestFn): [T[], T[]] => {
  const pass = [];
  const fail = [];
  array.forEach((
    item,
    index,
  ) => (test(item, index) ? pass : fail).push(item));
  return [pass, fail];
};
